import { EntityTablePagePartialProps } from "@crispico/foundation-react";
import { ReduxReusableComponents, RRCProps } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { EquipmentResourceTablePage, EquipmentResourceTablePageOptions, EquipmentResourceTablePageReducers, EquipmentResourceTablePageState } from "pages/EquipmentResource/equipmentResourceEntityDescriptor";
import { EntityTableSimpleDnDCellProps, EntityTableSimpleDnDCellRRC } from "./EntityTableSimpleDnDCell";
import { EntityTablePageWithGanttState } from "./EntityTablePageWithGantt";
import { XopsGanttPartialProps } from "./EntityTablePageWithGantt";
import { Mission } from "types";
import { RealTimeEmbeddedTableMixin } from "./RealTimeEmbeddedTableBase";
import { MenuActionId } from "@crispico/foundation-react";
const BaseClass = RealTimeEmbeddedTableMixin(EquipmentResourceTablePage);

export class RealTimeEquipmentResourceEmbeddedTableState extends EquipmentResourceTablePageState {
    protected static readonly defaultOptions: EquipmentResourceTablePageOptions = {
        ...EntityTablePageWithGanttState.defaultOptions,
        showBusiestSlotsPerEquipmentType: false,
        showGantt: true,
        compactMode: true
    };
    protected static readonly localStorageKey: string = 'RealTimeEquipmentResourceEmbeddedTable.options';
}
export class RealTimeEquipmentResourceEmbeddedTableReducers<S extends RealTimeEquipmentResourceEmbeddedTableState = RealTimeEquipmentResourceEmbeddedTableState> extends EquipmentResourceTablePageReducers<S> {
}

export type RealTimeEquipmentResourceEmbeddedTableProps = { getFullEntity?: (entityName: string, entity: any) => any; onRefresh?: () => Promise<void> } & EntityTablePagePartialProps & RRCProps<RealTimeEquipmentResourceEmbeddedTableState, RealTimeEquipmentResourceEmbeddedTableReducers>;

export class RealTimeEquipmentResourceEmbeddedTable extends BaseClass<RealTimeEquipmentResourceEmbeddedTableProps> {

    static defaultProps = {
        ...EquipmentResourceTablePage.defaultProps,
        embeddedMode: true,
        allowEmptyMissionDate: false
    }

    constructor(props: RealTimeEquipmentResourceEmbeddedTableProps) {
        super(props);
        this.tableSimpleClass = EntityTableSimpleDnDCellRRC as any;
    }

    protected showInMenu(key: MenuActionId) {
        return true;
    }

    setDate(date: string | null) {
        this.props.r.setInReduxState({ options: { ...this.props.s.options, date: date } });
    }

    async superRefresh() {
        console.log("refresh ers");
        return super.refresh();
    }

    async refresh() {
        if (this.props.onRefresh) {
            await this.props.onRefresh();
        } else {
            await this.superRefresh();
        }
    }

    protected async postRefreshHook(freshEntities: any[]): Promise<void> {
        await this.loadMissions(freshEntities);
    }

    getMission(missionId: any): Mission | undefined {
        const missionsByErId: { [erId: number]: Mission[] } = this.props.s.missionsByERId;
        if (!missionsByErId) {
            return undefined;
        }
        for (const erId in missionsByErId) {
            const mission = missionsByErId[erId].find((m: Mission) => m.id === missionId);
            if (mission) {
                return mission;
            }
        }
        return undefined;
    }

    protected getTableSimpleProps(): Partial<EntityTableSimpleDnDCellProps> | undefined {
        return {
            ...super.getTableSimpleProps(),
            onDrop: this.xopsGanttRef.current?.onDrop,
            "data-testid": "RealTimeEquipmentResourceEmbeddedTable"
        };
    }

    protected getXopsGanttProps(): XopsGanttPartialProps {
        return {
            ...super.getXopsGanttProps(),
            activatedDnD: true
        }
    }

    render() {
        return super.renderMain();
    }
}

export const RealTimeEquipmentResourceEmbeddedTableRRC = ReduxReusableComponents.connectRRC(RealTimeEquipmentResourceEmbeddedTableState, RealTimeEquipmentResourceEmbeddedTableReducers, RealTimeEquipmentResourceEmbeddedTable);
